import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  constructor(private readonly http: HttpClient) { }

  constants: Constants = new Constants();

  HTTP_CONSTANT_OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
      'Accept': 'application/json'
      //.'Access-Control-Allow-Origin': '*'
    })
  };


  getUserInfo(toyotaGUID): Observable<any> {
    console.info("Entered getUserInfo");

    return this.http
      .get(this.constants.getApiBasePath() + `/user/getuserinfo/${toyotaGUID}`, this.HTTP_CONSTANT_OPTIONS)
      .pipe(
        tap(_ => this.log('data success')),
        catchError(this.handleError<any>('data fails'))
      );
  }

  getUserInfoFreeze(toyotaGUID): Promise<any> {

    return this.http
      .get(this.constants.getApiBasePath() + `/user/getuserinfo/${toyotaGUID}`, this.HTTP_CONSTANT_OPTIONS)
      .pipe(map(res => res))
      .toPromise();
  }

  private handleError<T>(_operation, result?: T) {
    return (error: any): Observable<T> => {
      console.info(error); // log to console instead
      return of(result as T);
    };
  }

  /** Log a message */
  private log(message: string) {
    console.info('Message: ' + message);
  }

}
